import React, { useState, useCallback } from 'react'
import TextArea from 'react-textarea-autosize'
import Button from '../../Shared/Button'
import { sendMessage } from '../../../utils/socket'
import styles from './Composer.module.css'

export default function Composer() {
  const [value, setValue] = useState('')

  const handleSubmit = useCallback(
    e => {
      e.preventDefault()
      sendMessage(value)
      setValue('')
    },
    [value]
  )

  const handleKeyPress = useCallback(
    e => {
      if (e.key === 'Enter' && !e.shiftKey) {
        handleSubmit(e)
      }
    },
    [handleSubmit]
  )

  const handleChange = useCallback(
    event => {
      setValue(event.target.value)
    },
    [setValue]
  )

  return (
    <div className={styles.wrapper}>
      <form className={styles.innerWrapper} onSubmit={handleSubmit}>
        <TextArea
          placeholder="Type a message..."
          className={styles.input}
          value={value}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
        />
        <Button primary type="submit">
          Send
        </Button>
      </form>
    </div>
  )
}
